import { render, staticRenderFns } from "./tr.vue?vue&type=template&id=67f7ab2e&scoped=true"
import script from "./tr.vue?vue&type=script&lang=js"
export * from "./tr.vue?vue&type=script&lang=js"
import style0 from "./tr.vue?vue&type=style&index=0&id=67f7ab2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7ab2e",
  null
  
)

export default component.exports